import { ThemesDataResolver } from '@b2b/common/resolvers';
import uiRouter, { StateProvider } from '@uirouter/angularjs';
import angular from 'angular';
import { CustomersIndividualsDetailComponentModule } from './controllers/CustomersIndividualsDetailController';

export const customersIndividualsDetailView = angular
  .module('acme.view.application.customers.individuals.detail', [
    uiRouter,
    'ui.bootstrap',
    'acme.view.application.dataGrid.controllers',
    CustomersIndividualsDetailComponentModule,
    'acme.view.application.partners.create.createEditAddressModal.controllers',
  ])
  .config(function config($stateProvider: StateProvider) {
    $stateProvider.state({
      name: 'application.customers.individuals.detail',
      url: '/:id/detail',
      views: {
        'subview-main@application.customers.individuals': {
          component: 'acmeCustomersIndividualsDetail',
        },
      },
      data: {
        pageTitle: 'Customer Details',
        permissions: ['CUSTOMERS_VIEW'],
        enablePreferences: true,
      },
      resolve: {
        ThemesData: ThemesDataResolver({ includeEmail: true }),
      },
    });

    $stateProvider.state({
      name: 'application.customers.individuals.edit',
      url: '/:id/edit',
      views: {
        'subview-main': {
          component: 'acmeCustomersIndividualsDetail',
        },
      },
      data: {
        pageTitle: 'Customer Edit',
        permissions: ['CUSTOMERS_UPDATE'],
        enablePreferences: true,
      },
      resolve: {
        ThemesData: ThemesDataResolver({ includeEmail: true }),
      },
    });
  }).name;
